module.exports = __webpack_public_path__ + "media/images/abstract-bg-2-5e0e7b09d122895459151d919015186b.svg";